import { SOURCE_ID_TYPE_FILE } from 'Constants/index'
import { useIntl } from 'react-intl'
import { useRecoilState, useRecoilValue } from 'recoil'

import {
  Flex,
  FlexItem,
  Panel,
  RadioButton,
  SPACING_16,
  SPACING_24,
  SpacingVertical,
  Text,
  TEXT_VARIANT_BOLD,
  TEXT_VARIANT_LIGHT
} from 'mailup-web-components'

import {
  contentsState,
  sourceState
} from 'Pages/SourceEdit/recoil/state/source'

const ExistingContent = () => {
  const intl = useIntl()

  const { totalItems: totalContents } = useRecoilValue(contentsState)
  const [{ updateType, idType }, setUpdateType] = useRecoilState(sourceState)

  const handleChangeUpdateType = ({ target: { value } }) => {
    setUpdateType((prev) => ({ ...prev, updateType: +value, isDirty: true }))
  }

  if (idType !== SOURCE_ID_TYPE_FILE || totalContents <= 0) {
    return null
  }

  return (
    <Panel>
      <Text variant={TEXT_VARIANT_BOLD}>
        {intl.formatMessage({ id: 'Load.ContentsSouces.DataCollect' })}
      </Text>
      <SpacingVertical variant={SPACING_24} />
      <Flex flexDirection='column'>
        <RadioButton
          label={intl.formatMessage({
            id: 'Load.ContentsSouces.DataCollectRadioLbl1'
          })}
          onChange={handleChangeUpdateType}
          checked={updateType === 1}
          value={1}
          data-mu-test='source-edit__radio-replace'
        />
        <FlexItem margin='0 0 0 25px'>
          <Text variant={TEXT_VARIANT_LIGHT}>
            {intl.formatMessage({
              id: 'Load.ContentsSouces.RadioUpdateType1MessengerDescr'
            })}
          </Text>
        </FlexItem>
        <SpacingVertical variant={SPACING_16} />
        <RadioButton
          label={intl.formatMessage({
            id: 'Load.ContentsSouces.DataCollectRadioLbl2'
          })}
          onChange={handleChangeUpdateType}
          checked={updateType === 2}
          value={2}
          data-mu-test='source-edit__radio-add-new'
        />
        <FlexItem margin='0 0 0 25px'>
          <Text variant={TEXT_VARIANT_LIGHT}>
            {intl.formatMessage(
              {
                id: 'Load.ContentsSouces.RadioUpdateType2MessengerDescr'
              },
              { strong: (chunks) => <strong>{chunks}</strong> }
            )}
          </Text>
        </FlexItem>
      </Flex>
    </Panel>
  )
}

export default ExistingContent
